import { FuzzyMatcher } from "../../../models/matchers/FuzzyMatcher";
import { FuzzyInput } from "../../fuzzy/FuzzyInput";
import { FuzzyThreshold } from "../../fuzzy/FuzzyThreshold";
import { InputGroup } from "../../inputGroup/InputGroup";
import { MatcherLabel } from "../../inputGroup/MatcherLabel";
import { MatcherEditorChildProps } from "../MatcherEditor";

export { FuzzyMatcherEditor };

type Props = {
  matcher: FuzzyMatcher;
  update: (matcher: FuzzyMatcher) => void;
} & MatcherEditorChildProps<FuzzyMatcher>;

const FuzzyMatcherEditor = (props: Props) => {
  return (
    <InputGroup className={"matcherEditor fuzzyMatcherEditor"} button>
      <MatcherLabel label={"Fuzzy"} {...props} />

      <FuzzyInput
        initialValue={props.matcher.fuzzyKey}
        update={(result) => {
          props.matcher.fuzzyKey = result;
          props.update(props.matcher);
        }}
      />
      <FuzzyThreshold
        key={props.matcher.threshold}
        threshold={props.matcher.threshold}
        update={(threshold) => {
          props.matcher.threshold = threshold;
          props.update(props.matcher);
        }}
      />
      {props.button && props.button}
    </InputGroup>
  );
};
